import type { PropsWithChildren } from "react";
import { DeckLayoutContext } from "#deck-layout-context";
import { useDeckLayoutContextValue } from "#deck-layout-context-value";

export function DeckLayoutContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useDeckLayoutContextValue>[0]>) {
  const value = useDeckLayoutContextValue(props);
  return <DeckLayoutContext.Provider value={value}>{children}</DeckLayoutContext.Provider>;
}
